/* Uvan Kids - interaction layer for Shopify
   Cart runs on Shopify's AJAX Cart API (/cart/add.js, /cart/change.js, /cart.js).
   Wishlist and the star quest are per-browser (localStorage) - no app needed. */
(function () {
  'use strict';

  var S = window.UVAN_SHOP || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };

  /* ---------- money (Shopify money_format) ---------- */
  function money(cents) {
    var fmt = S.money_format || '{{amount}}';
    var value = Number(cents || 0) / 100;
    function withComma(n, dec) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return dec ? parts.join('.') : parts[0];
    }
    function indian(n, dec) {
      var s = n.toFixed(dec), p = s.split('.'), x = p[0];
      var last3 = x.slice(-3), rest = x.slice(0, -3);
      if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
      return dec ? last3 + '.' + p[1] : last3;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return indian(value, 2);
        case 'amount_no_decimals': return indian(Math.round(value), 0);
        case 'amount_with_comma_separator': return withComma(value, 2).replace(/,/g, '.').replace(/\.(\d\d)$/, ',$1');
        case 'amount_no_decimals_with_comma_separator': return withComma(Math.round(value), 0).replace(/,/g, '.');
        case 'amount_with_space_separator': return withComma(value, 2).replace(/,/g, ' ');
        default: return indian(value, 2);
      }
    });
  }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 2200);
  }

  /* ---------- confetti ---------- */
  var cv = $('#confetti'), cx = cv && cv.getContext('2d'), parts = [], raf = null;
  var COLS = ['#7CB342', '#29ABE2', '#F7931E', '#8E44AD', '#F48FB1', '#FFD54F'];
  function sizeCanvas() { if (cv) { cv.width = window.innerWidth; cv.height = window.innerHeight; } }
  sizeCanvas(); window.addEventListener('resize', sizeCanvas);
  function tick() {
    if (!cx) return;
    cx.clearRect(0, 0, cv.width, cv.height);
    parts = parts.filter(function (p) { return p.a > 0 && p.y < cv.height + 30; });
    parts.forEach(function (p) {
      p.x += p.vx; p.y += p.vy; p.vy += p.g; p.a -= 0.008; p.rot += 0.1;
      cx.save(); cx.globalAlpha = Math.max(0, p.a); cx.translate(p.x, p.y); cx.rotate(p.rot);
      cx.fillStyle = p.c; cx.fillRect(-p.r / 2, -p.r / 2, p.r, p.r * 0.6); cx.restore();
    });
    raf = parts.length ? requestAnimationFrame(tick) : null;
  }
  function burst(x, y, n) {
    if (!cx) return;
    for (var i = 0; i < (n || 40); i++) {
      parts.push({ x: x, y: y, vx: (Math.random() - 0.5) * 12, vy: -Math.random() * 10 - 3,
                   g: 0.35, r: Math.random() * 6 + 3, c: COLS[i % COLS.length], a: 1, rot: Math.random() * 6 });
    }
    if (!raf) tick();
  }
  function rain(n) {
    if (!cx) return;
    for (var i = 0; i < (n || 120); i++) {
      parts.push({ x: Math.random() * cv.width, y: -20, vx: (Math.random() - 0.5) * 4, vy: Math.random() * 4 + 2,
                   g: 0.12, r: Math.random() * 7 + 4, c: COLS[i % COLS.length], a: 1, rot: Math.random() * 6 });
    }
    if (!raf) tick();
  }

  /* ---------- reveal + tilt + sticky header ---------- */
  var io = window.IntersectionObserver ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;

  function wireEffects(root) {
    $$('.rv', root).forEach(function (e) { io ? io.observe(e) : e.classList.add('in'); });
    if (window.matchMedia('(pointer:fine)').matches) {
      $$('.tilt', root).forEach(function (c) {
        c.onmousemove = function (ev) {
          var r = c.getBoundingClientRect();
          var x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
          c.style.transform = 'rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 10) + 'deg) translateY(-6px)';
        };
        c.onmouseleave = function () { c.style.transform = ''; };
      });
    }
  }
  window.addEventListener('scroll', function () {
    var h = $('#hdr'); if (h) h.classList.toggle('scrolled', window.scrollY > 30);
  }, { passive: true });

  /* ---------- cart ---------- */
  function openCart() { var d = $('#drawer'), o = $('#ov'); if (d) d.classList.add('on'); if (o) o.classList.add('on'); }
  function closeCart() { var d = $('#drawer'), o = $('#ov'); if (d) d.classList.remove('on'); if (o) o.classList.remove('on'); }

  function drawCart(cart) {
    var n = cart.item_count, badge = $('#cartN');
    if (badge) { badge.textContent = n; badge.classList.toggle('hidden', !n); }
    var items = $('#cartItems'), foot = $('#cartFoot');
    if (!items) return;

    if (!n) {
      items.innerHTML = '<div class="empty"><div class="big">&#129528;</div>Your cart is empty.<br>' +
        '<a class="btn o sm" style="margin-top:14px" href="/collections/all">Start shopping</a></div>';
      if (foot) foot.innerHTML = '';
      return;
    }
    items.innerHTML = cart.items.map(function (i) {
      var variant = (i.variant_title && i.variant_title.indexOf('Default') === -1) ? esc(i.variant_title) + ' &middot; ' : '';
      return '<div class="ci" data-key="' + esc(i.key) + '">' +
        '<img src="' + esc(i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '') + '" alt="" width="76" height="76">' +
        '<div><b>' + esc(i.product_title) + '</b><small>' + variant + money(i.final_price) + '</small>' +
        '<div class="qty"><button type="button" data-qty="' + esc(i.key) + '" data-to="' + (i.quantity - 1) + '">&minus;</button>' +
        '<span>' + i.quantity + '</span>' +
        '<button type="button" data-qty="' + esc(i.key) + '" data-to="' + (i.quantity + 1) + '">+</button></div>' +
        '<button type="button" class="rm" data-qty="' + esc(i.key) + '" data-to="0">Remove</button></div>' +
        '<b>' + money(i.final_line_price) + '</b></div>';
    }).join('');

    if (foot) {
      var threshold = Number(S.free_ship_above || 0);
      var remaining = threshold - cart.total_price;
      var pct = threshold > 0 ? Math.min(100, cart.total_price / threshold * 100) : 100;
      foot.innerHTML =
        '<div class="tot"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
        '<div class="ship">' +
        (remaining > 0 ? 'Add ' + money(remaining) + ' more for FREE shipping &#128666;'
                       : '&#127881; You&rsquo;ve unlocked FREE shipping!') +
        '<div class="bar"><i style="width:' + pct + '%"></i></div></div>' +
        '<a class="btn o" style="width:100%;justify-content:center" href="/checkout" data-checkout>Checkout &rarr;</a>' +
        '<a class="btn w sm" style="width:100%;justify-content:center;margin-top:8px" href="/cart">View cart</a>';
    }
  }

  function refreshCart(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { drawCart(cart); if (open) openCart(); return cart; });
  }

  function flyToCart(fromEl, src) {
    var target = $('#cartBtn'); if (!target || !fromEl || !src) return;
    var from = fromEl.getBoundingClientRect(), to = target.getBoundingClientRect();
    var f = document.createElement('img');
    f.src = src; f.className = 'flyimg';
    f.style.left = (from.left + from.width / 2 - 40) + 'px';
    f.style.top = (from.top + from.height / 2 - 40) + 'px';
    document.body.appendChild(f);
    requestAnimationFrame(function () {
      f.style.left = (to.left + to.width / 2 - 10) + 'px';
      f.style.top = (to.top + to.height / 2 - 10) + 'px';
      f.style.width = f.style.height = '20px'; f.style.opacity = '.4';
    });
    setTimeout(function () { f.remove(); }, 850);
  }

  function addToCart(form) {
    var body = new FormData(form);
    var card = form.closest('.card') || form.closest('.pdp');
    var img = card && card.querySelector('img.a, .main img');
    var btn = form.querySelector('button[type=submit]');
    if (btn) btn.disabled = true;

    return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.d.description || res.d.message || 'Could not add that'); return; }
        toast('Added ' + (res.d.product_title || 'item') + ' 🎉');
        var cb = $('#cartBtn');
        if (cb) { cb.classList.remove('wig'); void cb.offsetWidth; cb.classList.add('wig'); }
        if (img) flyToCart(img, img.currentSrc || img.src);
        if (S.confetti !== false) {
          var r = (btn || form).getBoundingClientRect();
          burst(r.left + r.width / 2, r.top, 24);
        }
        setTimeout(function () { refreshCart(true); }, img ? 700 : 0);
      })
      .catch(function () { toast('Network hiccup - please try again'); })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        drawCart(cart);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  /* ---------- checkout (applies the star-quest discount) ---------- */
  function checkoutUrl() {
    var code = (S.quest_discount || '').trim();
    if (code && quest.done) return '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
    return '/checkout';
  }

  /* ---------- wishlist (per browser) ---------- */
  function lsGet(k, fallback) {
    try { return JSON.parse(localStorage.getItem(k)) || fallback; } catch (e) { return fallback; }
  }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  var wish = lsGet('uvan.wish', []);
  function paintWish() {
    var n = $('#wishN');
    if (n) { n.textContent = wish.length; n.classList.toggle('hidden', !wish.length); }
    $$('[data-wish]').forEach(function (b) {
      var on = wish.indexOf(b.getAttribute('data-wish')) > -1;
      b.classList.toggle('on', on);
      if (b.classList.contains('wish')) b.innerHTML = on ? '&#9829;' : '&#9825;';
      else b.innerHTML = on ? '&#9829; Saved' : '&#9825; Wishlist';
    });
  }
  function toggleWish(handle, btn) {
    var on = wish.indexOf(handle) === -1;
    wish = on ? wish.concat([handle]) : wish.filter(function (h) { return h !== handle; });
    lsSet('uvan.wish', wish); paintWish();
    toast(on ? 'Saved to wishlist ♥' : 'Removed from wishlist');
    if (on && btn && S.confetti !== false) {
      var r = btn.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2, 18);
    }
  }

  function renderWishlistPage() {
    var grid = $('[data-wishlist-grid]'); if (!grid) return;
    var empty = $('#wishEmpty');
    if (!wish.length) { if (empty) empty.classList.remove('hidden'); return; }
    Promise.all(wish.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      var html = list.filter(Boolean).map(function (p) {
        var v = p.variants[0];
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        return '<article class="card tilt">' +
          '<a class="ph" href="/products/' + esc(p.handle) + '">' +
          (sale ? '<span class="badge">-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%</span>' : '') +
          '<img class="a" src="' + esc(p.featured_image || '') + '" alt="' + esc(p.title) + '"></a>' +
          '<button type="button" class="wish on" data-wish="' + esc(p.handle) + '">&#9829;</button>' +
          '<div class="bd"><span class="col">' + esc(p.type || '') + '</span>' +
          '<h3><a href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a></h3>' +
          '<div class="price"><b>' + money(v.price) + '</b>' +
          (sale ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '</div>' +
          '<a class="btn o add sm" href="/products/' + esc(p.handle) + '">View</a></div></article>';
      }).join('');
      grid.innerHTML = html;
      if (!html && empty) empty.classList.remove('hidden');
      wireEffects(grid); paintWish();
    });
  }

  /* ---------- star quest ---------- */
  var QUEST_KEYS = ['friend1', 'friend2', 'friend3', 'quiz', 'sip'];
  var quest = lsGet('uvan.quest', {});
  function starCount() { return QUEST_KEYS.filter(function (k) { return quest[k]; }).length; }
  function paintStars(pop) {
    var n = starCount(), pill = $('#starpill'), num = $('#starN');
    if (num) num.textContent = n;
    if (pop && pill) { pill.classList.remove('pop'); void pill.offsetWidth; pill.classList.add('pop'); }
    var box = $('#quest'); if (!box) return;
    $$('.stars i', box).forEach(function (e, i) { e.classList.toggle('on', i < n); });
    var code = $('.code', box); if (code) code.classList.toggle('hidden', n < 5);
    var txt = $('.qtxt', box);
    if (txt) {
      txt.textContent = n >= 5
        ? 'Quest complete - the reward code is unlocked for the grown-ups!'
        : (5 - n) + ' more star' + (5 - n > 1 ? 's' : '') + ' to unlock a treat';
    }
  }
  function award(kind) {
    if (kind === 'friend') {
      var met = (quest.friendsMet || 0) + 1;
      quest.friendsMet = met;
      if (met <= 3) quest['friend' + met] = true;
    } else {
      if (quest[kind]) return;
      quest[kind] = true;
    }
    lsSet('uvan.quest', quest); paintStars(true);
    if (starCount() === 5 && !quest.done) {
      quest.done = true; lsSet('uvan.quest', quest);
      if (S.confetti !== false) rain(140);
      toast('🎉 Quest complete!' + (S.quest_discount ? ' Code ' + S.quest_discount + ' unlocked' : ''));
    }
  }

  /* ---------- hero ---------- */
  function heroLetters() {
    var h = $('[data-letters]'); if (!h || h.dataset.done) return;
    var text = h.textContent.trim(); h.dataset.done = '1'; h.textContent = '';
    var i = 0;
    text.split(' ').forEach(function (word, w) {
      if (w) h.appendChild(document.createTextNode(' '));
      var wrap = document.createElement('span');
      wrap.style.whiteSpace = 'nowrap';            // a word may wrap as a whole, never mid-word
      word.split('').forEach(function (ch) {
        var s = document.createElement('span');
        s.className = 'l'; s.textContent = ch; s.style.animationDelay = (i++ * 0.05) + 's';
        wrap.appendChild(s);
      });
      h.appendChild(wrap);
    });
  }
  function rotWords() {
    var el = $('#rot'); if (!el) return;
    var words = (el.getAttribute('data-words') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    if (words.length < 2) return;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % words.length;
      var w = words[i], k = 0; el.textContent = '';
      var t = setInterval(function () { el.textContent = w.slice(0, ++k); if (k >= w.length) clearInterval(t); }, 70);
    }, 2600);
  }
  function meetFriend(btn) {
    var box = btn.parentElement;
    $$('.bubble', box).forEach(function (b) { b.remove(); });
    var r = btn.getBoundingClientRect(), pr = box.getBoundingClientRect();
    var b = document.createElement('div');
    b.className = 'bubble';
    b.style.left = Math.max(0, Math.min(pr.width - 260, r.left - pr.left - 20)) + 'px';
    b.style.top = (r.top - pr.top - 118) + 'px';
    b.innerHTML = '<b>Hi, I&rsquo;m ' + esc(btn.dataset.name) + '! 👋</b>' + esc(btn.dataset.line) +
      '<br><a href="' + esc(btn.dataset.url) + '">Meet me &rarr; ' + esc(btn.dataset.price) + '</a>';
    box.appendChild(b);
    setTimeout(function () { b.remove(); }, 6000);
    if (!btn.classList.contains('met')) {
      btn.classList.add('met');
      if (S.confetti !== false) burst(r.left + r.width / 2, r.top + r.height / 2, 30);
      award('friend');
    }
  }

  /* ---------- buddy quiz ---------- */
  var quiz = { step: 0, score: {}, data: null };
  function quizRender() {
    var el = $('[data-quiz]'); if (!el || !quiz.data) return;
    var qs = quiz.data.questions || [], friends = quiz.data.friends || [];
    if (!qs.length || !friends.length) {
      el.innerHTML = '<div class="qn">Quiz</div><p style="font-weight:700;color:var(--mute)">' +
        'Add questions in the theme editor, and give at least one product the friend metafields.</p>';
      return;
    }
    if (quiz.step < qs.length) {
      var q = qs[quiz.step];
      el.innerHTML = '<div class="prog">' + qs.map(function (_, i) {
          return '<i class="' + (i <= quiz.step ? 'on' : '') + '"></i>'; }).join('') + '</div>' +
        '<div class="qn">Question ' + (quiz.step + 1) + ' of ' + qs.length + '</div>' +
        '<h3>' + esc(q.q) + '</h3><div class="opts">' +
        q.o.map(function (o, i) {
          return '<button type="button" class="opt" data-pick="' + i + '"><span>' + esc(o.e) + '</span>' + esc(o.t) + '</button>';
        }).join('') + '</div>';
    } else {
      var best = null, bestScore = -1;
      friends.forEach(function (f) {
        var sc = quiz.score[f.key] || 0;
        if (sc > bestScore) { bestScore = sc; best = f; }
      });
      best = best || friends[0];
      el.innerHTML = '<div class="qres"><img src="' + esc(best.img) + '" alt="">' +
        '<h3>You&rsquo;re a ' + esc(best.name) + '!</h3>' +
        '<p style="font-weight:700;color:var(--mute)">' + esc(best.line || '') + '</p>' +
        '<div class="buy" style="justify-content:center">' +
        '<a class="btn o" href="' + esc(best.url) + '">Meet ' + esc(best.name) + ' &middot; ' + esc(best.price) + '</a>' +
        '<button type="button" class="btn w sm" data-quiz-restart>Play again</button></div></div>';
      if (S.confetti !== false) rain(90);
      award('quiz');
    }
  }

  /* ---------- sip-o-meter ---------- */
  var sipSize = 450;
  function sipCalc(age, silent) {
    var slider = $('#age'); if (!slider) return;
    var ml = age <= 3 ? 1000 : age <= 8 ? 1200 + (age - 4) * 60 : age <= 13 ? 1500 + (age - 9) * 100 : 2100;
    var n = Math.ceil(ml / sipSize);
    $('#ageV').textContent = age;
    $('#sipMl').innerHTML = ml.toLocaleString('en-IN') + ' <small>ml / day</small>';
    $('#sipTxt').textContent = '≈ ' + n + ' refills of a ' + sipSize + ' ml bottle - about one every ' +
      (Math.round(10 / n * 10) / 10) + ' hours of a school day.';
    $('#refills').innerHTML = Array.apply(null, { length: n }).map(function (_, i) {
      return '<span style="animation-delay:' + (i * 0.05) + 's">💧</span>'; }).join('');
    $('#bw').style.height = Math.min(92, ml / 2400 * 100) + '%';
    $('#bface').textContent = age <= 5 ? '🥰' : age <= 10 ? '😄' : '😎';
    if (!silent) award('sip');
  }

  /* ---------- product page ---------- */
  function productPage() {
    var pdp = $('[data-product-page]'); if (!pdp) return;

    $$('.thumbs img', pdp).forEach(function (t) {
      t.addEventListener('click', function () {
        $('#pmain').src = t.getAttribute('data-full');
        $$('.thumbs img', pdp).forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
      });
    });

    var zoom = $('[data-zoom]', pdp);
    if (zoom && window.matchMedia('(pointer:fine)').matches) {
      zoom.addEventListener('mousemove', function (e) {
        zoom.style.setProperty('--ox', (e.offsetX / zoom.clientWidth * 100) + '%');
        zoom.style.setProperty('--oy', (e.offsetY / zoom.clientHeight * 100) + '%');
      });
    }

    var select = $('[data-variant-select]', pdp);
    function syncVariant() {
      if (!select) return;
      var chosen = $$('[data-option-index]', pdp).map(function (group) {
        var on = group.querySelector('.chip.on');
        return on ? on.getAttribute('data-value') : null;
      }).filter(function (v) { return v !== null; });
      if (!chosen.length) return;
      var title = chosen.join(' / ');
      var opt = Array.prototype.filter.call(select.options, function (o) {
        return o.getAttribute('data-title') === title;
      })[0];
      if (!opt) return;
      select.value = opt.value;
      var price = $('[data-price] b', pdp);
      if (price) price.textContent = opt.getAttribute('data-price');
      var submit = pdp.querySelector('#product-form button[type=submit]');
      if (submit) {
        submit.disabled = opt.disabled;
        submit.innerHTML = opt.disabled ? 'Sold out' : 'Add to cart &#128722;';
      }
    }

    $$('[data-option-index] .chip', pdp).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var group = chip.closest('[data-option-index]');
        $$('.chip', group).forEach(function (c) { c.classList.remove('on'); });
        chip.classList.add('on');
        syncVariant();
      });
    });

    $$('[data-pq]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var out = $('#pq'), input = $('#pqi');
        var next = Math.max(1, Number(out.textContent) + Number(b.getAttribute('data-pq')));
        out.textContent = next; if (input) input.value = next;
      });
    });

    var buyNow = $('[data-buy-now]', pdp);
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        var form = $('#product-form');
        addToCart(form).then(function () { window.location.href = checkoutUrl(); });
      });
    }
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-add]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;

    var open = t.closest('[data-cart-open]');
    if (open) { e.preventDefault(); refreshCart(true); return; }
    if (t.closest('[data-cart-close]') || t.id === 'ov') { closeCart(); return; }

    var qty = t.closest('[data-qty]');
    if (qty) { e.preventDefault(); changeQty(qty.getAttribute('data-qty'), Number(qty.getAttribute('data-to'))); return; }

    var checkout = t.closest('[data-checkout]');
    if (checkout) {
      var url = checkoutUrl();
      if (url === '/checkout') return;          // no reward code: let the normal link/form run
      e.preventDefault();
      var note = $('textarea[name=note]');       // keep whatever they typed on the cart page
      var save = note ? fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).catch(function () {}) : Promise.resolve();
      save.then(function () { window.location.href = url; });
      return;
    }

    var w = t.closest('[data-wish]');
    if (w) { e.preventDefault(); toggleWish(w.getAttribute('data-wish'), w); return; }

    var friend = t.closest('[data-friend]');
    if (friend) { meetFriend(friend); return; }

    var flip = t.closest('[data-flip]');
    if (flip) { flip.classList.toggle('on'); return; }

    var pick = t.closest('[data-pick]');
    if (pick) {
      var o = quiz.data.questions[quiz.step].o[Number(pick.getAttribute('data-pick'))];
      (o.s || []).forEach(function (k) {
        k = String(k).trim(); if (k) quiz.score[k] = (quiz.score[k] || 0) + 2;
      });
      quiz.step++; quizRender(); return;
    }
    if (t.closest('[data-quiz-restart]')) { quiz.step = 0; quiz.score = {}; quizRender(); return; }

    var size = t.closest('#sizeChips .chip');
    if (size) {
      sipSize = Number(size.getAttribute('data-ml')) || 450;
      $$('#sizeChips .chip').forEach(function (c) { c.classList.remove('on'); });
      size.classList.add('on');
      sipCalc(Number($('#age').value));
      return;
    }

    if (t.closest('[data-quest-jump]')) {
      var q = $('#quest');
      if (q) q.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else window.location.href = '/';
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.id === 'age') sipCalc(Number(e.target.value));
  });

  /* ---------- boot ---------- */
  function init() {
    if (S.sparkle_cursor !== false) document.body.classList.add('sparkle');
    wireEffects(document);
    heroLetters();
    rotWords();
    productPage();
    paintWish();
    paintStars(false);
    renderWishlistPage();

    var qd = $('[data-quiz-data]');
    if (qd) { try { quiz.data = JSON.parse(qd.textContent); } catch (err) { quiz.data = null; } quizRender(); }

    if ($('#age')) sipCalc(Number($('#age').value), true);

    // keep the badge and drawer in step with the server-rendered cart
    refreshCart(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Shopify theme editor re-renders sections without a page load
  document.addEventListener('shopify:section:load', function () {
    wireEffects(document); heroLetters(); rotWords(); productPage(); paintWish(); paintStars(false);
    var qd = $('[data-quiz-data]');
    if (qd) { try { quiz.data = JSON.parse(qd.textContent); quiz.step = 0; quiz.score = {}; } catch (err) {} quizRender(); }
    if ($('#age')) sipCalc(Number($('#age').value), true);
  });
})();
